import { css } from '@emotion/react';
import { theme } from '../../../theme';

const layoutStyle = css`
  padding: 0;
  min-height: 99.9vw;
  display: flex;
  flex-direction: column;
`;

const activateLayoutStyle = css`
  padding: 0;
  display: flex;
  flex-direction: column;
`;

const layoutFooterStyle = css`
  flex-shrink: 1;
`;

export {
  layoutStyle,
  activateLayoutStyle,
  layoutFooterStyle,
};
